import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../redux/hooks';
import './SignUpStu.scss';
import { SubmitHandler, useForm } from "react-hook-form"
import Field from '../../components/Field/Field';
import { Lektors } from '../../utils/consts';
import { queryString } from '../../utils/queryString';
import LatinaController from '../../API/LatinaController';
import SButton from '../../components/UI/Button/SButton';
import BrandLogo from '../../components/UI/BrandLogo/BrandLogo';
import BotController from '../../API/BotController';

interface MainProps {
  title?: string;
}

export interface ISignUpForm {
  login: string
  name: string
  email: string
  phone: string
  date: string
  linkVk: string
  promo: string
}

const SignUpStu: FC<MainProps> = ({
  title = "Заявка на регистрацию"
}) => {

  const loggedIn = useAppSelector((state) => state.usersR.loggedIn)

  const { register: formRegister, handleSubmit, formState: { errors }, reset, getValues, setError, clearErrors } = useForm<ISignUpForm>({ mode: "onChange" })

  const [loginVerified, setLoginVerified] = useState(false);

  const [sendDisable, setSendDisable] = useState(false);

  const [checked, setChecked] = useState(false);

  function chengeCheckbox() {
    setChecked(!checked);
  }

  let navigate = useNavigate();

  const promoLektor: Record<string, string> = {}
  Lektors.map((lektor: string, ind: number) => promoLektor[`la${ind + 1}`] = lektor)

  const titleM = title;
  const AuthApp = (data: ISignUpForm) => {
    setSendDisable(true)

    const queryParams = {
      login: data.login,
      name: data.name,
      email: data.email,
      phone: data.phone,
      date: data.date,
      linkVk: data.linkVk,
      promo: data.promo,
    }

    const dataBot = {
      peer_id: Number(process.env.REACT_APP_PEER_ID_GROUP),
      message: `Заявка на регистрацию:
Логин: ${data.login}
ФИО: ${data.name}
E-mail: ${data.email}
Телефон: ${data.phone}
Дата рождения: ${data.date}
Профиль ВК: ${data.linkVk}
Промокод: ${data.promo}

Ссылка для регистрации: ${process.env.REACT_APP_DOM_SEND_2}/sign-up?${queryString(queryParams)}

`
    }
    BotController.peer(dataBot)
    BotController.logWrite(dataBot)

    const dataSendLog = {
      login: process.env.REACT_APP_USER_ONE,
      message: `Заявка на регистрацию:
Логин: ${data.login}
ФИО: ${data.name}
E-mail: ${data.email}
Телефон: ${data.phone}
Дата рождения: ${data.date}
Профиль ВК: ${data.linkVk}
Промокод: ${data.promo}

Ссылка для регистрации: ${process.env.REACT_APP_DOM_SEND_2}/sign-up?${queryString(queryParams)}

`
    }
    fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram/log-write`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataSendLog)
    })

    const dataSend = {
      login: process.env.REACT_APP_USER_ONE,
      message: `Заявка на регистрацию:
Логин: ${data.login}
ФИО: ${data.name}
E-mail: ${data.email}
Телефон: ${data.phone}
Дата рождения: ${data.date}
Профиль ВК: ${data.linkVk}
Промокод: ${data.promo}

Ссылка для регистрации: ${process.env.REACT_APP_DOM_SEND_2}/sign-up?${queryString(queryParams)}

`
    }

    fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataSend)
    })

    const dataSend2 = {
      login: process.env.REACT_APP_USER_TWO,
      message: `Заявка на регистрацию:
Логин: ${data.login}
ФИО: ${data.name}
E-mail: ${data.email}
Телефон: ${data.phone}
Дата рождения: ${data.date}
Профиль ВК: ${data.linkVk}
Промокод: ${data.promo}

Ссылка для регистрации: ${process.env.REACT_APP_DOM_SEND_2}/sign-up?${queryString(queryParams)}

`
    }


    fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataSend2)
    })


    const dataSend4 = {
      login: process.env.REACT_APP_USER_THREE,
      message: `Заявка на регистрацию:
Логин: ${data.login}
ФИО: ${data.name}
E-mail: ${data.email}
Телефон: ${data.phone}
Дата рождения: ${data.date}
Профиль ВК: ${data.linkVk}
Промокод: ${data.promo}

Ссылка для регистрации: ${process.env.REACT_APP_DOM_SEND_2}/sign-up?${queryString(queryParams)}

`
    }


    fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataSend4)
    })
    console.log(promoLektor[data.promo])

    const dataSend3 = {
      login: promoLektor[data.promo] ? promoLektor[data.promo] : '',
      message: `Заявка на регистрацию:
Логин: ${data.login}
ФИО: ${data.name}
E-mail: ${data.email}
Телефон: ${data.phone}
Дата рождения: ${data.date}
Профиль ВК: ${data.linkVk}
Промокод: ${data.promo}

Ссылка для регистрации: ${process.env.REACT_APP_DOM_SEND_2}/sign-up?${queryString(queryParams)}

`
    }


    fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataSend3)
    })

    setTimeout(() => {
      alert(`Пользователь ${data.name}, Ваша заявка отправлена. Ждите ответа, в течение суток Вам ответит администратор`)

      reset()

      setSendDisable(false)
      setChecked(false)

      setSendDisable(false)
    }, 2000)


  }

  const AuthClose = () => {
    navigate('/')
  }

  const validLogin = /^[a-zA-Z0-9_-]+$/
  const validName = /^[а-яА-ЯёЁ -]+$/
  const validEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const validPhone = /^[0-9]{11}$/
  const validDate = /^[0-9]{4}-[0-1]{1}[0-9]{1}-[0-3]{1}[0-9]{1}$/

  const onSubmit: SubmitHandler<ISignUpForm> = async (data) => {
    const isUniqueAvailable = await checkUnique();

    if (!isUniqueAvailable) {
      return;
    }

    AuthApp(data);
  }


  const checkLogin = async () => {
    setLoginVerified(false); // Сбрасываем статус перед проверкой
    if (errors.login) {
      return
    }
    const formData = getValues();
    if (!formData.login) {
      setError("login", {
        type: "required",
        message: "Введите логин для проверки",
      });
      return false;
    }

    try {
      const dataSend = { login: formData.login };
      const check = await LatinaController.checkLogin(dataSend);

      if (!check) {
        setError("login", {
          type: "manual",
          message: "Логин уже занят",
        });
        return false;
      } else {
        clearErrors("login"); // Очищаем ошибку, если логин свободен
        setLoginVerified(true); // Устанавливаем статус при успешной проверке
        return true;
      }
    } catch (error) {
      setError("login", {
        type: "manual",
        message: "Ошибка проверки логина",
      });
      return false;
    }
  };

  const checkUnique = async () => {
    setLoginVerified(false); // Сбрасываем статус перед проверкой
    const formData = getValues();

    try {
      const dataSend = { login: formData.login, email: formData.email, phone: formData.phone };
      const check: string = await LatinaController.checkUnique(dataSend);

      if (check) {
        check.split(',').map(thisCheck => {


          setError(thisCheck.trim() as ('login' | 'phone' | 'email'), {
            type: "manual",
            message: "Уже занят",
          });

        })
        return false;
      } else {
        clearErrors('login'); // Очищаем ошибку, если логин свободен
        clearErrors('email'); // Очищаем ошибку, если почта свободна
        clearErrors('phone'); // Очищаем ошибку, если телефон свободен
        return true;
      }

    } catch (error) {
      setError("login", {
        type: "manual",
        message: "Ошибка проверки логина",
      });
      return false;
    }
  };

  return (
    <div className="application">
      <div className='application__content'>
        <div className='application__content-wrapper'>
          <BrandLogo />
          <div className='application__content-box'>


            <div style={{ textAlign: 'center' }} >
              {titleM}
            </div>
            {!loggedIn ?
              <div className='application-form'>
                <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column', rowGap: '5px' }} >
                  <Field
                    {...formRegister('login', {
                      required: 'Логин обязательное поле',
                      pattern: {
                        value: validLogin,
                        message: 'Допустимы латиница, _ и -'
                      },
                      onBlur: () => checkLogin() // Проверка при уходе с поля
                    })}
                    label='Логин*'
                    placeholder='ironman'
                    error={errors.login?.message}
                  />

                  <Field
                    {...formRegister('name', {
                      required: 'ФИО обязательное поле',
                      pattern: {
                        value: validName,
                        message: 'Допустимы кириллица, -, пробел'
                      }
                    })}
                    label='ФИО*'
                    placeholder='Иванов Иван Иваныч'
                    error={errors.name?.message}
                  />

                  <Field
                    {...formRegister('email', {
                      required: 'Email обязательное поле',
                      pattern: {
                        value: validEmail,
                        message: 'Некорректный формат почты'
                      }
                    })}
                    label='Почта*'
                    placeholder='ironman@gmail.com'
                    error={errors.email?.message}
                  />

                  <Field
                    {...formRegister('phone', {
                      required: 'Телефон обязательное поле',
                      pattern: {
                        value: validPhone,
                        message: 'Допустимы только цифры'
                      }
                    })}
                    label='Телефон*'
                    placeholder='88001234567'
                    error={errors.phone?.message}
                  />

                  <Field
                    {...formRegister('date', {
                      required: 'Дата рождения обязательное поле',
                      pattern: {
                        value: validDate,
                        message: 'Формат обязателен: ГГГГ-ММ-ДД'
                      }
                    })}
                    label='Дата рождения*'
                    placeholder='2023-01-31'
                    error={errors.date?.message}
                  />

                  <Field
                    {...formRegister('linkVk')}
                    label='Профиль vk'
                    placeholder='https://vk.com/id1'
                    error={errors.linkVk?.message}
                  />

                  <Field
                    {...formRegister('promo')}
                    label='Комментарий к заявке'
                    error={errors.promo?.message}
                  />

                  <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'baseline' }}>
                    <input id='oferta' type="checkbox" checked={checked} onChange={chengeCheckbox} style={{ marginRight: "10px" }} />
                    <label htmlFor='oferta' style={{ lineHeight: "24px" }}>
                      <span>Согласен с </span>
                      <span className='inline-block'>
                        <a href={'/politik'} target='_blank'>политикой обработки персональных данных</a>
                      </span>
                    </label>
                  </div>

                  <div>
                    <SButton disabled={sendDisable || !checked} type='submit'>Подать заявку</SButton>
                  </div>
                </form>
              </div>
              :
              <SButton onClick={AuthClose}>Войти</SButton>
            }
            <div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUpStu;
